import { render, staticRenderFns } from "./my_profile.vue?vue&type=template&id=67d91454&scoped=true"
import script from "./my_profile.vue?vue&type=script&lang=js"
export * from "./my_profile.vue?vue&type=script&lang=js"
import style0 from "./my_profile.vue?vue&type=style&index=0&id=67d91454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d91454",
  null
  
)

export default component.exports